import React, { useEffect, useRef } from 'react';
import {AdProcessPC, AdProcessTestMobile, AdWrapper} from './styles';

const adProcessUnitsConfigs = {
    "adfox_155903485178447293": { // [Desktop] В Тесте
        counter: 0, // Добавленный счётчик для reload
        hb: [
            {
                "code": "adfox_155903485178447293",
                "codeType": "combo",
                "sizes": [
                    [970, 250]
                ],
                "bids": [
                    {
                        "bidder": "betweenDigital",
                        "params": {
                            "placementId": "3141094"
                        }
                    },
                    {
                        "bidder": "buzzoola",
                        "params": {
                            "placementId": "1221640",
                            "sendTargetRef": true
                        }
                    },
                    {
                        "bidder": "gnezdo",
                        "params": {
                            "placementId": "19205"
                        }
                    },
                    {
                        "bidder": "sape",
                        "params": {
                            "placementId": "871373"
                        }
                    },
                    {
                        "bidder": "myTarget",
                        "params": {
                            "placementId": "1685616"
                        }
                    }
                    // ,{
                    //     "bidder": "adriver",
                    //     "params": {
                    //         "placementId": "112:testometrika_inpage"
                    //     }
                    // }
                    // ,{
                    //     "bidder": "adfox_adtech",
                    //     "params": {
                    //         p1: 'crttt',
                    //         p2: 'gbyx'
                    //     }
                    // }
                ]
            }
        ],
        createParams: {
            ownerId: 285496,
            containerId: "adfox_155903485178447293",
            params: {
                "pp": "g",
                "ps": "dhvq",
                "p2": "gkpp",
                "puid1": "", // эти параметры подставим динамически
                "partner-stat-id": "" // эти параметры подставим динамически
            }
        }
    },
    "adfox_155903566903998072": { // [Mobile] В Тесте
        counter: 0, // Добавленный счётчик для reload
        hb: [
            {
                "code": "adfox_155903566903998072",
                "codeType": "combo",
                "sizes": [
                    [300, 250]
                ],
                "bids": [
                    {
                        "bidder": "betweenDigital",
                        "params": {
                            "placementId": "3131028"
                        }
                    },
                    {
                        "bidder": "buzzoola",
                        "params": {
                            "placementId": "1220529",
                            "sendTargetRef": true
                        }
                    },
                    {
                        "bidder": "gnezdo",
                        "params": {
                            "placementId": "19211"
                        }
                    },
                    {
                        "bidder": "sape",
                        "params": {
                            "placementId": "871375"
                        }
                    },
                    {
                        "bidder": "myTarget",
                        "params": {
                            "placementId": "1683735"
                        }
                    }
                    // ,{
                    //     "bidder": "adriver",
                    //     "params": {
                    //         "placementId": "112:testometrika_inpage"
                    //     }
                    // }
                    // ,{
                    //     "bidder": "adfox_adtech",
                    //     "params": {
                    //         p1: 'crttu',
                    //         p2: 'y'
                    //     }
                    // }
                ]
            }
        ],
        createParams: {
            ownerId: 285496,
            containerId: 'adfox_155903566903998072',
            params: {
                "pp": 'g',
                "ps": 'dhvq',
                "p2": 'gkpt',
                "puid1": "", // эти параметры подставим динамически
                "partner-stat-id": "" // эти параметры подставим динамически
            }
        },
    }
};

/**
 * Создание нового рекламного блока AdFox
 * @param {string} containerId - ID контейнера для рекламы
 * @param {string} testIdString - ID теста для передачи в параметрах
 * @returns {boolean} - Успешно ли создан блок
 */
const createAdfoxBlock = (containerId, testIdString) => {
    const config = adProcessUnitsConfigs[containerId];
    if (!config) {
        console.error(`Не найдена конфигурация для ID ${containerId}`);
        return false;
    }

    // Создаем новый ID для контейнера
    const newId = `${containerId}_${++config.counter}`;

    // Создаем глубокую копию конфигурации
    const newConfig = JSON.parse(JSON.stringify(config));
    newConfig.hb[0].code = newId;
    newConfig.createParams.containerId = newId;
    newConfig.createParams.params.puid1 = testIdString;
    newConfig.createParams.params['partner-stat-id'] = testIdString;

    // Находим контейнер в DOM
    const oldElement = document.getElementById(containerId);
    if (!oldElement) {
        console.error(`Базовый элемент с ID ${containerId} не найден`);
        return false;
    }

    // Подготавливаем новый элемент внутри контейнера
    const newDiv = document.createElement('div');
    newDiv.id = newId;
    newDiv.className = oldElement.className;
    newDiv.style.cssText = oldElement.style.cssText;

    // Очищаем контейнер и добавляем новый элемент
    oldElement.innerHTML = '';
    oldElement.appendChild(newDiv);

    try {
        // Отправляем блок в header bidding
        if (window.Ya && window.Ya.headerBidding && window.Ya.headerBidding.pushAdUnits) {
            window.Ya.headerBidding.pushAdUnits(newConfig.hb);
        }

        // Создаем рекламный блок через yaContextCb (не модифицируя его)
        if (window.yaContextCb && typeof window.yaContextCb.push === 'function') {
            window.yaContextCb.push(() => {
                if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.create) {
                    window.Ya.adfoxCode.create(newConfig.createParams);
                    console.log(`Создан новый блок с ID ${newId}`);
                }
            });
        } else {
            console.warn('window.yaContextCb недоступен или не является массивом');
        }

        return true;
    } catch (error) {
        console.error('Ошибка при создании Adfox блока:', error);
        return false;
    }
};

/**
 * Перезагрузка рекламного блока AdFox
 * @param {string} containerId - ID контейнера для рекламы
 * @param {string} testIdString - ID теста для передачи в параметрах
 * @returns {boolean} - Успешно ли перезагружен блок
 */
const reloadAdfoxBlock = (containerId, testIdString) => {
    const config = adProcessUnitsConfigs[containerId];
    if (config && config.counter > 0) {
        // Если уже был создан хотя бы один новый контейнер
        const previousId = `${containerId}_${config.counter}`;

        // Удаляем старый блок через destroy
        if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.destroy) {
            window.Ya.adfoxCode.destroy(previousId);
            // console.log(`Удален блок: ${previousId}`);
        }
    }

    // Создаем новый блок
    return createAdfoxBlock(containerId, testIdString);
};

/**
 * Компонент для отображения рекламных блоков AdFox
 */
const AdfoxProcess = ({ testId, isDesktop }) => {
    const intervalRef = useRef(null);
    const reloadAdsTimer = 60000; // 60 сек
    const activeContainerId = isDesktop ? 'adfox_155903485178447293' : 'adfox_155903566903998072';

    useEffect(() => {
        const idTestString = testId.toString();

        // Функция инициализации рекламы
        const initializeAds = () => {
            // console.log(`Инициализация рекламы для типа устройства: ${isDesktop ? 'desktop' : 'mobile'}`);
            createAdfoxBlock(activeContainerId, idTestString);
        };

        // 1. Вызываем инициализацию после короткой задержки для уверенности, что DOM готов
        const initTimeout = setTimeout(() => {
            // Регистрируем колбэк для header bidding
            if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.hbCallbacks) {
                window.Ya.adfoxCode.hbCallbacks.push(initializeAds);
            } else {
                // Если API не готово, попробуем напрямую
                console.warn('Ya.adfoxCode.hbCallbacks недоступен, инициализируем напрямую');
                initializeAds();
            }
        }, 100);

        // 2. Устанавливаем интервал для обновления рекламы
        // @ts-ignore
        intervalRef.current = setInterval(() => {
            // Обновляем рекламу только если вкладка видима
            if (!document.hidden) {
                console.log(`Обновление: ${activeContainerId}`);
                reloadAdfoxBlock(activeContainerId, idTestString);
            }
        }, reloadAdsTimer);

        // Функция очистки при размонтировании компонента
        return () => {
            clearTimeout(initTimeout);

            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }

            // Уничтожаем последний созданный блок, если он есть
            const config = adProcessUnitsConfigs[activeContainerId];
            if (config && config.counter > 0) {
                const currentId = `${activeContainerId}_${config.counter}`;
                if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.destroy) {
                    window.Ya.adfoxCode.destroy(currentId);
                    // console.log(`Удален блок при размонтировании: ${currentId}`);
                }
            }
        };
    }, [testId, isDesktop, activeContainerId]);

    // Рендерим только контейнер, соответствующий текущему типу устройства
    return (
        <AdWrapper>
            {isDesktop ? (
                <AdProcessPC id="adfox_155903485178447293"></AdProcessPC>
            ) : (
                <AdProcessTestMobile id="adfox_155903566903998072"></AdProcessTestMobile>
            )}
        </AdWrapper>
    );
};

export default AdfoxProcess;